// store/helpers/unique_values.js
// function returning array containing single values from another array

export const getUniqueValues = (source, key, id = '', addEmptyLine = false, secondField = '') => {
  const uniqueValues = Array.from(new Set(source.map(obj => obj[key])));

  const temp = id
    ? uniqueValues.map(item => {
        const foundObj = source.find(obj => obj[key] === item);
        const mappedRes = {
          id: foundObj ? foundObj[id] : item,
          description: item
        };
        if (secondField) mappedRes[secondField] = foundObj[secondField];
        return mappedRes;
      })
    : uniqueValues.map(item => ({ id: item, description: item }));

  const res = temp.sort((a, b) => 
    !id
      ? String(a.id).localeCompare(String(b.id), undefined, { sensitivity: 'base' })
      : Number(a.id) - Number(b.id)
  );

  if (addEmptyLine) res.unshift({ id: 0, description: '' });

  return res;
};
